import { ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PlatformComponent, PlatformService } from '@evc/platform';
import { ToastService } from '@evc/web-components';
import { Component, OnInit } from '@angular/core';
import {
  MsalBroadcastService,
} from '@azure/msal-angular';
import { EventType } from '@azure/msal-browser';

import { NavConfigService } from './services/nav-config/nav-config.service';

@Component({
  standalone: true,
  imports: [RouterModule, PlatformComponent],
  selector: 'app-root',
  templateUrl: 'app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  readonly #navConfigService = inject(NavConfigService);
  readonly #platformService = inject(PlatformService);
  readonly #msalBroadcastService = inject(MsalBroadcastService);
  readonly #toastService = inject(ToastService);
  ngOnInit() {
    this.#msalBroadcastService.msalSubject$.subscribe((event) => {
      if (event.eventType === EventType.LOGIN_FAILURE) {
        this.#toastService.error(event.error?.message ?? 'unknown')
      }
    });
  }

  ready = this.#platformService.ready;
  helpMenu = this.#navConfigService.helpMenu.asReadonly();
  settingsMenu = this.#navConfigService.settingsMenu.asReadonly();
  leftbarConfig = this.#navConfigService.leftbarConfig.asReadonly();
  appIdentification = this.#navConfigService.appIdentity.asReadonly();
}
